import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/sys/dept/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}
export const remove = (ids) => {
  return request({
    url: '/sys/dept/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const add = (row) => {
  return request({
    url: '/sys/dept/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/sys/dept/submit',
    method: 'post',
    data: row
  })
}

export const getDept = (id) => {
  return request({
    url: '/sys/dept/detail',
    method: 'get',
    params: {
      id
    }
  })
}
export const getDeptTree = () => {
  return request({
    url: '/sys/dept/tree',
    method: 'get'
  })
}

export const getParentId = (parentId) => {
  return request({
    url: '/sys/dept/parentId',
    method: 'get',
    params: {
      parentId
    }
  })
}

export const isValidName = (name, id) => {
  return request({
    url: '/sys/dept/check/name',
    method: 'get',
    params: {
      name,
      id
    }
  })
}
